<ng-container *ngIf="disruptions" data-elastic-exclude>
  <ng-container *ngFor="let item of getMappedDisruptions(); trackBy: disruptionItemId">
    <fcom-notification
      *ngIf="!item.hidden"
      class="border-bottom"
      [layout]="NotificationLayout.BLOCK_MAX_GRID"
      [theme]="item.level"
      [linkText]="item.linkText || (item.linkUrl ? ('readMore' | finLocalization) : null)"
      [linkUrl]="item.linkUrl"
      [isClosable]="isGlobalBanner ? showGlobalBannerClose(item) : true"
      (linkClick)="onLinkClick($event, item)"
      (closeClick)="onClose(item)"
    >
      {{ item.text }}
    </fcom-notification>
  </ng-container>
</ng-container>
